import React from 'react';
import Input, { InputProps } from './Input';
import { IconNames } from '@blueprintjs/icons';

// tslint:disable-next-line:no-empty-interface
export interface PasswordInputProps extends InputProps {}

const PasswordInput = ({ ...props }: PasswordInputProps) => (
  <Input leftIcon={IconNames.KEY} {...props} type="password" />
);

export default PasswordInput;
